import React, { useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  loadCampaignItemDetailPage,
  unloadCampaignItemDetailPage,
  sendSMSViaCampaignItem
} from "../../redux/actions/asset.actions";
import Nav from "../../components/Nav";
import Header from "../../components/Header";
import * as DateHelper from "../../utils/date.formatter";
import CampaignItemEventList from "../../components/CampaignItemEventList";
import GoogleMapReact from "google-map-react";
import LocationMarker from "../../components/LocationMarker";
import { Translation } from "react-i18next";
import i18n from "../../languages/lang.js";

function CampaignItem({}) {
  let { key } = useParams();
  const asset = useSelector(state => state.asset);
  const common = useSelector(state => state.common);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(loadCampaignItemDetailPage(key));
    return () => dispatch(unloadCampaignItemDetailPage());
  }, [key]);
  const handleSendSMS = () => ev => {
    ev.preventDefault();
    if (window.confirm(i18n.t("campaign.send_confirm_msg"))) {
      dispatch(sendSMSViaCampaignItem(key));
    }
  };

  if (!asset.campaignItem) {
    return (
      <Translation>
        {t => (
          <div id="main">
            <Nav selected={"campaigns"} />
            <div id="content">
              <Header />
              <div id="loading">{t("system.loading")}</div>
            </div>
          </div>
        )}
      </Translation>
    );
  }
  const campaignItem = asset.campaignItem;
  const lastEvent =
    campaignItem.client_details && Array.isArray(campaignItem.client_details)
      ? campaignItem.client_details[0]
      : null;
  return (
    <Translation>
      {t => (
        <div id="main">
          <Nav selected={"campaigns"} />
          <div id="content">
            <Header />
            <div className="content-wrap">
              <div className="box-header">
                <span className="header-info">
                  {t("common.created")}:{" "}
                  {DateHelper.toLocalString(campaignItem.created)}
                </span>
                <h2>
                  <Link to={`/campaigns/${campaignItem.campaign_key}`}>
                    {campaignItem.campaign_name}
                  </Link>{" "}
                  &gt; {campaignItem.asset_number}
                </h2>
              </div>
              <ul className="dashboard-list">
                <li>
                  <strong>{t("common.status")}</strong>
                  <em>
                    {t(
                      "campaign.item_status_" +
                        campaignItem.status.toLowerCase()
                    )}
                  </em>
                </li>
                <li>
                  <strong>{t("common.response")}</strong>
                  <em>
                    {t(
                      "campaign.item_response_status_" +
                        campaignItem.client.toLowerCase()
                    )}
                  </em>
                </li>
                <li>
                  <strong>{t("common.last_location")}</strong>
                  <em className="shorter">
                    {lastEvent
                      ? `lon:${lastEvent.value.longitude}, lat:${lastEvent.value.latitude}`
                      : "n/a"}
                  </em>
                </li>
              </ul>
              <div
                className={
                  lastEvent
                    ? "box-sms-message box-sms-message-alt"
                    : "box-sms-message"
                }
              >
                <span>
                  <strong>{t("campaign.label_sms_message")}:</strong>
                  {campaignItem.campaign_notes}
                  <em>https://iso.pellar.io/{campaignItem.key}</em>
                </span>
              </div>
              {lastEvent ? (
                <div className={"map-box map-box-alt"}>
                  <GoogleMapReact
                    bootstrapURLKeys={{
                      key: "AIzaSyChP3vkShVB0f9F_pWR-f9RoevDAuY5lPQ"
                    }}
                    defaultCenter={{
                      lat: lastEvent.value.latitude,
                      lng: lastEvent.value.longitude
                    }}
                    defaultZoom={12}
                  >
                    {campaignItem.client_details &&
                    Array.isArray(campaignItem.client_details)
                      ? campaignItem.client_details.slice(0, 19).map(item => {
                          return (
                            <LocationMarker
                              key={item.time}
                              lat={item.value.latitude}
                              lng={item.value.longitude}
                              time={item.time}
                            />
                          );
                        })
                      : null}
                  </GoogleMapReact>
                </div>
              ) : (
                ""
              )}
            </div>
            <div className="content-wrap">
              <div className="box-header">
                <a className="header-button" onClick={handleSendSMS()}>
                  {common.inProgress
                    ? t("system.sending_feeback")
                    : t("campaign.send_sms_button")}
                </a>
                <h2>{t("campaign.campaign_detail_events")}</h2>
              </div>
              <CampaignItemEventList data={campaignItem.client_details || []} />
            </div>
          </div>
        </div>
      )}
    </Translation>
  );
}

export default CampaignItem;
